import { ECodeType } from '@app/swagger-types';

export const gs1CsvFieldMap: Record<string, string> = {
  // Required
  Name: 'name',
  'GTIN (EAN) Code': 'gs1.gtin',
  Title: 'gs1.title',

  // Optional
  Description: 'gs1.description',

  // Optional customLinks (to 10)
  'Link 1 title': 'gs1.customLinks[0].title',
  'Link 1 URL': 'gs1.customLinks[0].url',
  'Link 2 title': 'gs1.customLinks[1].title',
  'Link 2 URL': 'gs1.customLinks[1].url',
  'Link 3 title': 'gs1.customLinks[2].title',
  'Link 3 URL': 'gs1.customLinks[2].url',
  'Link 4 title': 'gs1.customLinks[3].title',
  'Link 4 URL': 'gs1.customLinks[3].url',
  'Link 5 title': 'gs1.customLinks[4].title',
  'Link 5 URL': 'gs1.customLinks[4].url',
  'Link 6 title': 'gs1.customLinks[5].title',
  'Link 6 URL': 'gs1.customLinks[5].url',
  'Link 7 title': 'gs1.customLinks[6].title',
  'Link 7 URL': 'gs1.customLinks[6].url',
  'Link 8 title': 'gs1.customLinks[7].title',
  'Link 8 URL': 'gs1.customLinks[7].url',
  'Link 9 title': 'gs1.customLinks[8].title',
  'Link 9 URL': 'gs1.customLinks[8].url',
  'Link 10 title': 'gs1.customLinks[9].title',
  'Link 10 URL': 'gs1.customLinks[9].url',
};

// TODO: Remove Partial type
export const csvFieldMapsByType: Partial<Record<ECodeType, Record<string, string>>> = {
  [ECodeType.GS1]: gs1CsvFieldMap,
  [ECodeType.WEBSITE]: {
    Name: 'name',
    'Website URL': 'websiteUrl',
  },
};

export const csvHeadersByType: Partial<Record<ECodeType, string[]>> = {
  [ECodeType.WEBSITE]: ['Name', 'Website URL'],
  [ECodeType.GS1]: ['Name', 'GTIN (EAN) Code', 'Title'],
};
